import { API_REFERENCE } from '../utilities/constant_api';
import { htmlGet } from '../components/ajax';
import { truncateText } from '../utilities/utility';
$(function() {
  const accountDropdownActiveEle = $('#account-dropdown-active-item');
  const getAlertsOnLoad = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutAlerts.getAlertsOnLoad}`;
  const numberOfAlertsBadge = $('#numberOfAlertsBadge');
  const alertTopDiv = '.alertdropdownlistDetails';
  const windowlocalStorageEle = window.localStorage;
  let accoutPopup = false;
  let alertPopup = false;
  var suggestions = [];
  var typeAhead = [];
  // Matching Typeahead keyword
  var $meganavWrapper = $('.meganav-wrapper');
  var $megaNav = $('.meganav');
  var secondaryNavClicked;
  var secondaryPrevNavClicked = '';
  var bIsSubpanelExpanded = false;
  var bIsInitialLoad = true;
  var searchPlaceholder = $('.js-site-search-input').attr('placeholder');

  function checkMSIE() {
    var detectIEregexp;

    if (navigator.userAgent.indexOf('MSIE') != -1) {
      detectIEregexp = /MSIE (\d+\.\d+);/; //test for MSIE x.x
    } else {
      detectIEregexp = /Trident.*rv[ :]*(\d+\.\d+)/; //test for rv:x.x or rv x.x where Trident string exists
    } // if no "MSIE" string in userAgent

    if (detectIEregexp.test(navigator.userAgent)) {
      //if some form of IE
      var ieversion = new Number(RegExp.$1); // capture x.x portion and store as a number
    }
    if (ieversion >= 11) {
      $('.meganav').addClass('isMSIE');
    } else {
      $('.meganav').addClass('isNonIE');
    }
  }
  checkMSIE();

  $('#sortOptions1').focusin(function() {
    $('#sortOptions1').addClass('search-results-sortCol__select--focus');
  });
  $('#sortOptions1').focusout(function() {
    $('#sortOptions1').removeClass('search-results-sortCol__select--focus');
  });

  function searchKeyup(event) {
    var searchVal = event.target.value.toLowerCase();
    var pressedkey = event.key;

    if (searchVal !== '' && pressedkey !== 'Enter' && searchVal.length >= 4) {
      $('.nav-search-remove').removeClass('hidden');
    } else {
      $('.nav-search-entry').removeClass('nav-search-entry--open');
      $('.nav-search-entry').addClass('nav-search-entry--focus');
      $('nav-search-remove').addClass('hidden');
    }
  }
  function searchBlur() {
    $(this).attr('placeholder', searchPlaceholder);
  }
  function hideDropdownAction() {
    $('.nav-search-remove').addClass('hidden');
    $('.nav-search-entry').removeClass('nav-search-entry--open');
    $('.nav-search-entry').addClass('nav-search-entry--focus');
  }
  function logInMobile() {
    $('.nav-loggedInProfile').addClass('show');
    $('.nav-loggedInProfile').removeClass('hidden');
    $('.search-empty-container').css('margin-top', '190px');
    $('.search-sort').css('margin-top', '190px');
    $('.product-detail').css('margin-top', '190px');
    $('.search-refine-container').css('margin-top', '30px');
    $('.product-price-signin-xs').addClass('hidden');
    $('.product-price-signin-xs').removeClass('visible-xs-block');
    $('.product-price-btn-row').addClass('show');
    $('.product-price-btn-row').removeClass('hidden');
    $('.product-coverage-row').addClass('show');
    $('.product-coverage-row').removeClass('hidden');
    $('.product-detail-card-desc-buy-price').addClass('show');
    $('.product-detail-card-desc-buy-price').removeClass('hidden');
    $('.product-detail-card-desc-buy-signin').addClass('hidden');
    $('.product-detail-card-desc-buy-signin').removeClass('show');
    $('.product-detail-card-desc-cov').removeClass('hidden');
    $('.product-detail-card-desc-cov').addClass('show');
    $('.product-detail-card-info-note').removeClass('hidden');
    $('.product-detail-card-info-note').addClass('show');
  }

  function logInDesktop() {
    $('.nav-loggedInProfile').addClass('show');
    $('.nav-loggedInProfile').removeClass('hidden');
    $('.product-price-btn-row').addClass('show');
    $('.product-price-btn-row').removeClass('hidden');
    $('.product-coverage-row').addClass('show');
    $('.product-coverage-row').removeClass('hidden');
    $('.product-detail-card-desc-buy-price').addClass('show');
    $('.product-detail-card-desc-buy-price').removeClass('hidden');
    $('.product-detail-card-desc-cov').removeClass('hidden');
    $('.product-detail-card-desc-cov').addClass('show');
    $('.product-detail-card-info-note').removeClass('hidden');
    $('.product-detail-card-info-note').addClass('show');
  }

  function logOut() {
    $('.nav-profile').addClass('show');
    $('.nav-profile').removeClass('hidden');
    $('.nav-loggedInProfile').removeClass('show');
    $('.search-empty-container').css('margin-top', '-=30px');
    $('.search-sort').css('margin-top', '-=30px');
    $('.search-refine-container').css('margin-top', '160px');
    $('.product-price-signin').addClass('show');
    $('.product-price-signin').removeClass('hidden');
    $('.product-price-signin-xs').addClass('visible-xs-block');
    $('.product-price-signin-xs').removeClass('hidden');
    $('.product-price-row-breaker').addClass('hidden');
    $('.product-price-row-breaker').removeClass('show');
    $('.product-price-btn-row').addClass('hidden');
    $('.product-price-btn-row').removeClass('show');
    $('.product-coverage-row').addClass('hidden');
    $('.product-coverage-row').removeClass('show');
    $('.product-add-cart').addClass('show');
    $('.product-add-cart').removeClass('hidden');
    $('.product-detail-card-desc-buy-price').addClass('hidden');
    $('.product-detail-card-desc-buy-price').removeClass('show');
    $('.product-detail-card-desc-buy-signin').addClass('show');
    $('.product-detail-card-desc-buy-signin').removeClass('hidden');
    $('.product-detail-card-desc-cov').removeClass('show');
    $('.product-detail-card-desc-cov').addClass('hidden');
    $('.product-detail-card-info-note').removeClass('show');
    $('.product-detail-card-info-note').addClass('hidden');
  }

  function focusOnSearch() {
    if (
      !(
        $('.dropdown-menu').css('display') === undefined ||
        $('.dropdown-menu').css('display') === 'none'
      )
    ) {
      $('.nav-search-entry').removeClass('nav-search-entry--focus');
      $('.nav-search-entry').addClass('nav-search-entry--open');
    } else {
      $('.nav-search-entry').removeClass('nav-search-entry--open');
      $('.nav-search-entry').addClass('nav-search-entry--focus');
    }
    if (searchPlaceholder != '') {
      $(this)
        .data('placeholder', searchPlaceholder)
        .removeAttr('placeholder');
    }
  }

  function updateDropdownActiveItem() {
    const targetEle = $(this);
    windowlocalStorageEle.setItem(
      'accountsDropdownActiveValue',
      targetEle.find('a').text()
    );
    windowlocalStorageEle.setItem(
      'accountsDropdownActiveId',
      targetEle
        .find('a')
        .parent()
        .attr('id')
    );
    targetEle.find('a').attr('data-active', 'currentActiveMenu');
  }
  
  function updateStorageDataForActiveItem() {
    const targetEle = $(this);
    const text = targetEle.find('.accountLandingPage__card--content--title span').text();
    windowlocalStorageEle.setItem(
      'accountsDropdownActiveValue',
      text
    );
  }

  function firstLastName() {
    const fullName = $('#usernameInitials').val();
    if (fullName != undefined && fullName != '') {
      const splitfullName = fullName.split(' ');
      const firstNameletter = splitfullName[0].substr(0, 1);
      const lastNameletter = splitfullName[splitfullName.length - 1].substr(
        0,
        1
      );
      $('.nav-loggedInProfile-icon').html(
        firstNameletter + '' + lastNameletter
      );
    }
  }

  function updateAriaLabelMenuActiveItem() {
    const dropdownActiveItem = windowlocalStorageEle.getItem(
      'accountsDropdownActiveId'
    );
    $(`#${dropdownActiveItem}`)
      .find('a')
      .attr('aria-label', 'current page');
    $(`#account-dropdown-menu-section #${dropdownActiveItem}`)
      .find('a')
      .attr('aria-label', 'current page');
  }

  function initDropdownActiveItem() {
    if ($('#account-dropdown-active-row').length) {
      $('#account-dropdown-active-row').removeClass('invisible');
      if (window.innerWidth <= 767) {
        $('#account-dropdown-active-item').attr(
          'aria-label',
          $('.breadcrumb-item.active span:last')
            .text()
            .trim() +
            ' ' +
            'Dropdown Menu'
        );
      }
      if (
        windowlocalStorageEle.getItem('accountsDropdownActiveValue') !== null ||
        window.location.href.indexOf('viewAlerts') > -1
      ) {
        if (window.innerWidth <= 1367) {
          if (
            windowlocalStorageEle.getItem('accountsDropdownActiveValue') !==
            null
          ) {
            accountDropdownActiveEle.text(
              windowlocalStorageEle.getItem('accountsDropdownActiveValue')
            );
            updateAriaLabelMenuActiveItem();
          } else {
            const viewAlertsPageTitle = $('#AccountAlerts')
              .find('a')
              .text();
            accountDropdownActiveEle.text(viewAlertsPageTitle);
            windowlocalStorageEle.setItem(
              'accountsDropdownActiveValue',
              viewAlertsPageTitle
            );
            windowlocalStorageEle.setItem(
              'accountsDropdownActiveId',
              'AccountAlerts'
            );
            updateAriaLabelMenuActiveItem();
          }
        } else {
          updateAriaLabelMenuActiveItem();
        }
      } else {
        windowlocalStorageEle.removeItem('accountsDropdownActiveValue');
      }
    }
  }

  function mobileAccessibilityChange() {
    let $menuButton = $('.accountHeaderText.account-heading');
    let $menuHeading = $menuButton.find('#account-dropdown-active-item');
    let $dropDownIcon = $menuButton.find('.accountLinkToggle');
    let $primaryBtn = $('.nav-primary-btn');
    let primaryAccordian = '.nav-primary-btn-icon';
    let subNavSection = '.sub-nav-col';
    let secondaryNav = '.secondary-nav-links';
    if (window.innerWidth <= 767) {
      $('ol.breadcrumb.hidden-xs')
        .parent('nav')
        .attr('aria-hidden', true);
      let ariaLabel = $menuHeading.attr('aria-label');
      $menuButton.attr('aria-label', ariaLabel);
      $menuHeading.attr('aria-hidden', true);
      $dropDownIcon.attr('aria-hidden', true);
      $primaryBtn.each(function() {
        let menuItemsCount = $(this)
          .next('ul.accordion')
          .find('li.nav-secondary-btn').length;
        let menuAriaLabel = $(this)
          .find(primaryAccordian)
          .attr('data-label');
        $(this)
          .find(primaryAccordian)
          .attr(
            'aria-label',
            menuAriaLabel + ' with list of ' + menuItemsCount + ' items'
          );
      });

      $(subNavSection)
        .find(secondaryNav)
        .each(function() {
          let counter =
            $(this)
              .parents(subNavSection)
              .find($(this))
              .parent()
              .index() + 1;
          let finalsubNavObj = [];
          let subNavListCount = $(this)
            .parents(subNavSection)
            .find('ul li').length;
          for (let count = 0; count < subNavListCount; count++) {
            if (
              $(this)
                .parents(subNavSection)
                .find('ul li .secondary-nav-links:eq(' + count + ')')
                .text()
                .trim() !== ''
            ) {
              finalsubNavObj.push($(this));
            }
          }
          let finalAriaLabel =
            $(this).attr('data-label') +
            ' ' +
            counter +
            ' of ' +
            finalsubNavObj.length;
          $(this).attr('aria-label', finalAriaLabel);
        });
    } else {
      if ($menuHeading.attr('aria-hidden') === true) {
        $menuButton.removeAttr('aria-label');
        $menuHeading.removeAttr('aria-hidden');
        $dropDownIcon.removeAttr('aria-hidden');
      }
      $('ol.breadcrumb.hidden-xs')
        .parent('nav')
        .removeAttr('aria-hidden');
      $primaryBtn.each(function() {
        let menuAriaLabel = $(this)
          .find(primaryAccordian)
          .attr('data-label');
        $(this)
          .find(primaryAccordian)
          .attr('aria-label', menuAriaLabel);
      });
      $(secondaryNav).each(function(i) {
        let finalAriaLabel = $(this).attr('data-label');
        $(this).attr('aria-label', finalAriaLabel);
      });
    }
  }

  firstLastName();
  initDropdownActiveItem();
  mobileAccessibilityChange();
  function setFocusToLogo() {
    $('.nav-menu-btn').click();
    setTimeout(function() {
      $('.nav-logo')
        .focus()
        .attr('aria-label', 'mega menu closed edgpark logo home page');
    }, 250);
  }
  $('.nav-logo').on('focusout', function() {
    $(this).attr('aria-label', 'edgpark logo home page');
  });

  $(document).on('keydown', '.subnav-cont-wrapper:visible a:last', function(e) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setFocusToLogo();
    }
  });
  $(document).on('keydown', 'ul.Gethelp:visible a:last', function(e) {
    if (
      e.keyCode === 9 &&
      !e.shiftKey &&
      $('.subnav-cont-wrapper:visible').length === 0
    ) {
      setFocusToLogo();
    }
  });
  $(document).on('keydown', '.nav-primary-btn-icon:last', function(e) {
    if (
      e.keyCode === 9 &&
      !e.shiftKey &&
      $('.subnav-cont-wrapper:visible').length === 0 &&
      $('ul.Gethelp:visible').length === 0
    ) {
      setFocusToLogo();
    }
  });
  $(document).on('keydown', '#text-link-signin', function(e) {
    if (
      e.keyCode === 9 &&
      e.shiftKey &&
      $('.subnav-cont-wrapper:visible').length === 0 &&
      $('ul.Gethelp:visible').length === 0
    ) {
      $('.nav-menu-btn').click();
      setTimeout(function() {
        $('.nav-menu-btn').focus();
      }, 250);
    }
  });
  $('.custom-invert-button').on('click', logOut);
  $('.nav-profile-sm__btn').on('click', logInDesktop);
  $('.nav-profile').on('click', logInMobile);
  $('.nav-search-icon,.nav-search-remove').on('click', hideDropdownAction);
  $('.nav-search-entry')
    .on('keyup', searchKeyup)
    .on('focus', focusOnSearch)
    .on('blur', searchBlur);
  $(document).on(
    'click',
    '.accNavComponent__child-wrap div',
    updateDropdownActiveItem
  );
  $(document).on(
    'click',
    '.accountLandingPage__card .accountLandingPage__card--content .accountLandingPage__card--content--customizeImg',
    updateStorageDataForActiveItem
  );
  
  $('.accountHeaderText').on('click', toggleMobileNavExpand);
  $('.nav-secondary-btn-link').on('keyup', subMenuEnter);
  $(window).on('resize', mobileAccessibilityChange);

  if ($('#account-dropdown-menu-section').length) {
    if (window.innerWidth <= 1367) {
      $('.accountHeaderText').click();
    }
  }

  function toggleMobileNavExpand(e) {
    if (window.innerWidth <= 1367) {
      assignLabelToMenu();
      let accountDropdownHeader = $('.accountHeaderText');
      accountDropdownHeader.toggleClass('downarrow');
      if (accountDropdownHeader.hasClass('downarrow')) {
        accountDropdownHeader.attr('aria-expanded', 'false');
      } else {
        accountDropdownHeader.attr('aria-expanded', 'true');
      }
      if (e.originalEvent !== undefined) {
        $('#mainPageToggler .accNavComponent').slideToggle();
      } else {
        $('#account-dropdown-menu-section').removeClass(
          'hidden-xs hidden-sm hidden-md'
        );
        $('#account-dropdown-menu-section .accNavComponent').css(
          'display',
          'none'
        );
      }
      setTimeout(function() {
        if ($('.accNavComponent').is(':visible') == true) {
          $('.accountHeaderText').addClass('expanded');
        } else {
          $('.accountHeaderText').removeClass('expanded');
        }
      }, 250);
    }
  }

  function recalculateMeganavHeight() {
    if (bIsInitialLoad === true) {
      if ($(window).width() >= 768) {
        $(
          ".nav-secondary-btn-link[data-clicked='".concat(
            secondaryNavClicked,
            "']"
          )
        ).click();
        bIsInitialLoad = false;
      }
    }

    if ($(window).width() >= 768) {
      // Getting width of scrollbar
      if ($('.meganav.scrollbar').length > 0) {
        const scrollbarWidth =
          $('.meganav.scrollbar')[0].offsetWidth -
          $('.meganav.scrollbar')[0].clientWidth;
        $('.meganav-content-container').css('width', '100%');
        $('#subNavPanelContent').css(
          'width',
          $('.navbar').innerWidth() -
            $('.main-nav-col').innerWidth() -
            (scrollbarWidth + 1)
        );
      }
    } else {
      $('.meganav-content-container').css('width', '200%');
      $('#subNavPanelContent').css('width', '50%');

      // apply 50% width only for mobile breakpoint when not on IE browser,
      // otherwise IE overflow will wrap flyout content to bottom of screen
      if ($('.meganav').hasClass('isMSIE')) {
        $('#subNavPanelContent').css('left', '0');
      }
    }

    $megaNav.css(
      'height',
      document.documentElement.clientHeight -
        ($('.nav-marketing').height() + $('.nav-header').height())
    );
    $('.left-nav-panel-cont-wrapper, .right-nav-panel-cont-wrapper').css(
      'height',
      '100%'
    );

    if ($(window).width() >= 768) {
      if (document.documentMode || /Edge/.test(navigator.userAgent)) {
        if (!$('.meganav').hasClass('main-nav-only')) {
          $('.meganav-2col-wrapper').css('height', '100vh');
        } else {
          $('.meganav-2col-wrapper').css('height', '100%');
        }
      } else {
        $('.meganav-2col-wrapper').css('height', '100%');
      }
    } else {
      $('.meganav-2col-wrapper').css('height', '100%');
    }
    setTimeout(function() {
      $megaNav.addClass('ie-meganav-mobile-bgcolor-override');
    }, 100);
  }

  function hideSubNavContent() {
    $('.nav-inner').removeClass('show');
    $('#subNavPanelContent').css('display', 'none');
    $('.subnav-cont-wrapper').css('display', 'none');
    $('.nav-secondary-btn').removeClass('active');
  }
  function toggleMegaNav() {
    $meganavWrapper.toggleClass('expanded');

    if ($meganavWrapper.hasClass('expanded')) {
      $meganavWrapper.show();
      $('.mobile-nav-overlay').fadeIn();
      $megaNav
        .removeClass('overflow-none')
        .addClass('ie-meganav-mobile-bgcolor-override');
      $megaNav.addClass('main-nav-only');
      if ($('#text-link-signin').length) {
        $('#text-link-signin').focus();
      } else {
        $('.nav-primary-btn-icon')
          .first()
          .focus();
      }
    } else {
      $megaNav
        .addClass('overflow-none')
        .removeClass('ie-meganav-mobile-bgcolor-override');
      $('.mobile-nav-overlay').fadeOut();
      if (!bIsInitialLoad) {
        hideSubNavContent();
      }
      $('.accordion ').css('display', 'none');
      $('.nav-primary-btn').removeClass('active');
      $('.nav-primary-btn')
        .eq(0)
        .addClass('active');
      $('.accordion ')
        .eq(0)
        .css('display', 'block');
      $meganavWrapper.hide();
    }

    setTimeout(recalculateMeganavHeight, 250);
  }

  $('#nav-toggle').on('click', function(e) {
    e.preventDefault();
    if (bIsInitialLoad) {
      $meganavWrapper.show();
    }
    toggleMegaNav();
  });

  $meganavWrapper.hide();
  $('.nav-primary-btn-icon').on('click', function(e) {
    $megaNav.addClass('main-nav-only');
    e.preventDefault();
    hideSubNavContent();
    var $thisClicked = $(e.target).parent();
    var thisIconCategory = $(e.target).attr('data-nav-prime');
    $('.nav-primary-btn[data-nav-prime!="'.concat(thisIconCategory, '"]'))
      .removeClass('active')
      .next()
      .slideUp();
    $thisClicked.toggleClass('active');
    if ($thisClicked.hasClass('active')) {
      $thisClicked.find('a').attr('aria-expanded', 'true');
    } else {
      $thisClicked.find('a').attr('aria-expanded', 'false');
    }
    $thisClicked.next().slideToggle();
    setTimeout(recalculateMeganavHeight, 250);
  });

  $('.nav-primary-btn')
    .first()
    .find('.icon')
    .click();

  function closeMobileNav() {
    toggleMegaNav();
  }

  function backToMainNav() {
    $('.meganav-wrapper').removeClass('expanded-secondary');
    secondaryPrevNavClicked = secondaryNavClicked;
    $('.nav-secondary-btn').removeClass('active');
    var bIsToggled = false;
    toggleSecondaryNav(secondaryNavClicked, bIsToggled);
  }

  function toggleSecondaryNav(param, bIsToggled) {
    $('.meganav-2col-wrapper').css('height', '100%');
    var $meganavSubPanel = $('#subNavPanelContent');
    $meganavSubPanel.show();
    $megaNav
      .addClass('overflow-none')
      .removeClass('ie-meganav-mobile-bgcolor-override'); // if sidenav expanded already

    if (bIsSubpanelExpanded === true) {
      $meganavSubPanel.removeClass('show');
      $megaNav.addClass('overflow-none');
      setTimeout(function() {
        $('.'.concat(secondaryPrevNavClicked, '-nav-cont')).hide();

        if (bIsToggled) {
          $('.'.concat(param, '-nav-cont')).show();
          $meganavSubPanel.addClass('show');
          $megaNav.removeClass('main-nav-only');
          $('.'.concat(param, '-nav-cont'))
            .find('.subnav-cont-col a')
            .first()
            .focus();

          setTimeout(function() {
            $megaNav.removeClass('overflow-none');
            bIsSubpanelExpanded = true;
            recalculateMeganavHeight();
          }, 250);
        } else {
          bIsSubpanelExpanded = false;
          $meganavSubPanel.hide();
          $megaNav.addClass('main-nav-only');
          $megaNav.removeClass('overflow-none');
          $('.meganav-wrapper').removeClass('expanded-secondary');
          setTimeout(function() {
            recalculateMeganavHeight();
          }, 250);
        }
      }, 250);
    } else {
      $megaNav.removeClass('main-nav-only');
      $megaNav.removeClass('overflow-none');
      $('.'.concat(param, '-nav-cont')).show();
      $meganavSubPanel.addClass('show');
      setTimeout(function() {
        $('.'.concat(param, '-nav-cont'))
          .find('.subnav-cont-col a')
          .first()
          .focus();
        $megaNav.removeClass('overflow-none');
        bIsSubpanelExpanded = true;
        setTimeout(recalculateMeganavHeight, 250);
      }, 250);
    }
  }

  $('.nav-secondary-btn-link').click(function(e) {
    openSubmenu(e);
  });

  function subMenuEnter(e) {
    if (e.keyCode === 13) {
      $(this).trigger('click');
    }
  }

  function assignLabelToMenu() {
    let activePage = $('.breadcrumb-item.active span:last')
      .text()
      .trim();
    if (activePage.toLowerCase() === 'billing and payments') {
      activePage = 'Billing & Payments';
    } else if (
      activePage.toLowerCase() === 'insurance, doctors and conditions'
    ) {
      activePage = 'Insurance, Doctors and Health Conditions';
    }
    $('.accNavComponent__child-wrap a').each(function() {
      if (
        $(this)
          .text()
          .trim()
          .toLowerCase() === activePage.toLowerCase()
      ) {
        $(this).attr(
          'aria-label',
          $(this)
            .text()
            .trim() + ' selected'
        );
      }
    });
  }

  function openSubmenu(e) {
    var thisClicked = $(e.target);
    var thisData = e.currentTarget.getAttribute('data-clicked');
    
    /* to check nav my account click */
    if(thisClicked.parent().parent().hasClass('Myaccount') == true){
		let txtData = thisClicked.text().trim();
		windowlocalStorageEle.setItem('accountsDropdownActiveValue',txtData);
	}
	
    $('.nav-secondary-btn[data-clicked!='.concat(thisData, ']')).removeClass(
      'active'
    );
    $(e.target)
      .parent()
      .toggleClass('active');
    var bIsToggled = $(e.target)
      .parent()
      .hasClass('active');

    if (!thisClicked.hasClass('direct-link')) {
      e.preventDefault();
      secondaryPrevNavClicked = secondaryNavClicked;
      secondaryNavClicked = e.currentTarget.getAttribute('data-clicked');
      $('.meganav-wrapper').addClass('expanded-secondary');
      toggleSecondaryNav(secondaryNavClicked, bIsToggled);
      $(e.target).attr('aria-expanded', bIsToggled);
    }
    $('.dynamic-category-image').each(function() {
      let textTrim = $(this)
        .find('h4')
        .text();
      $(this)
        .parent()
        .find('img')
        .attr('alt', textTrim);
    });
  }

  $('.mobile-nav-close').click(closeMobileNav);
  $('.back-to-nav-btn').click(backToMainNav); // only pre-expand secondary nav if initial window is greater than sm-min
  if (window.innerWidth >= 768) {
    $(
      '.nav-secondary-btn-link[data-clicked="'.concat(secondaryNavClicked, '"]')
    ).click();
    bIsInitialLoad = false;
  }
  $(window).resize(recalculateMeganavHeight);
  recalculateMeganavHeight();
  $('.dropdown-list').click(function() {
    $('.alertdropdownlistDetails').removeClass('show');
    if ($('.dropdownlistDetails').hasClass('show')) {
      $('.dropdownlistDetails').removeClass('show');
      $('.nav-loggedInProfile-btn').attr('aria-expanded', false);
      if (window.innerWidth < 768) {
        $('.pageType-ContentPage').css('overflow-y', '');
        $('.pageType-ContentPage').css('height', '');
      }
    } else {
      $('.dropdownlistDetails').addClass('show');
      $('.nav-loggedInProfile-btn').attr('aria-expanded', true);
      if (window.innerWidth < 768) {
        $('.pageType-ContentPage').css('overflow-y', 'hidden');
        $('.pageType-ContentPage').css('height', '100vh');
      }
      assignLabelToMenu();
    }
  });

  $('.nav-loggedInProfile-notif-btn,.ui-autocomplete-input').on(
    'focus',
    function() {
      $('.dropdownlistDetails').removeClass('show');
      $('.nav-loggedInProfile-btn').attr('aria-expanded', false);
    }
  );

  // on page init for my-account
  setTimeout(function() {
    if (window.location.href.indexOf('my-account-home') > -1) {
      if ($('.accNavComponent').is(':visible') == true) {
        $('.accountHeaderText').addClass('expanded');
      } else {
        $('.accountHeaderText').removeClass('expanded');
      }
    }
  }, 100);
  function signUpForAnAccount() {
    $('.header-signin')[0].click();
  }

  function closeDialogOnEsc(e) {
    if (e.keyCode == 27) {
      if ($('.subnav-cont-wrapper').is(':visible')) {
        hideSubNavContent();
        $('.nav-secondary-btn.active').focus();
      } else if ($('.expanded-secondary').is(':visible')) {
        $('.nav-menu-btn').click();
      }
    }
  }

  $(document).on('click', 'body', function (evt) {
    if ($('.meganav-wrapper').hasClass('expanded') && !($(evt.target).hasClass('header__hamburger') || $(evt.target).hasClass('nav-menu-btn'))
      && $('.meganav-wrapper').find(evt.target).length == 0) {
      toggleMegaNav();
    }

    if(!$(evt.target).hasClass('hide-signIn-dropdown') && $('.hide-signIn-dropdown').has(evt.target).length === 0 && !$(evt.target).hasClass('header-signin btn-link')){
      $('.hide-signIn-dropdown').hide();
    }

    if ($('.dropdownlistDetails').hasClass('show') && !($(evt.target).hasClass('nav-loggedInProfile-btn') || $(evt.target).hasClass('nav-loggedInProfile-icon'))
      && $('.dropdownlistDetails').find(evt.target).length == 0) {
          $('.dropdownlistDetails').removeClass('show');
          $('.nav-loggedInProfile-btn').attr('aria-expanded', false);
    }
  });
  
  $(document).ready(function() {
    var nonCheckoutFlow = location.pathname.indexOf('checkout') === -1;
    if (location.pathname.indexOf('orderConfirmation') >= 0) {
      nonCheckoutFlow = true;
    }
    if (nonCheckoutFlow) {
      htmlGet(getAlertsOnLoad).then(response => {
        if (response) {
          let responseData = JSON.parse(response);
          if (responseData.errorMessage !== null) {
            if ($('.generic-error-container').length > 0) {
              $('.generic-error-container').each(function() {
                if (!$(this).hasClass('generic-modal-error')) {
                  $(this)
                    .find('.generic-error-text')
                    .text(responseData.errorMessage);
                  $(this).removeClass('hidden');
                }
              });
            } else {
              $('.global-error-message-container')
                .find('.generic-error-text')
                .text(responseData.errorMessage);
              $('.global-error-message-container').removeClass('hidden');
            }
            window.scrollTo(0, 0);
            if ('scrollRestoration' in window.history) {
              window.history.scrollRestoration = 'manual';
            }
          } else {
            let numberOfAlerts = responseData.numberOfAlerts;            
            if (numberOfAlerts > 0) {
              numberOfAlertsBadge.removeClass('hidden');
              numberOfAlertsBadge.text(numberOfAlerts);
            }
          }
        } else {
          function error(XMLHttpRequest, textStatus, errorThrown) {}
        }
      });
    }
    $('.accNavComponent__child-wrap div').each(function() {
      $(this)
        .children('a')
        .attr('aria-label', $(this).children('a')[0].outerText);
    });

    $(document).on('keyup', closeDialogOnEsc);

    const numberOflistItems = $(
      '.dropdownlistDetails .accNavComponent>nav'
    ).children('div').length;
    let ariaLabelValue = 'Account list ' + numberOflistItems + ' items';
    $('.nav-loggedInProfile-btn').attr('aria-label', ariaLabelValue);
    assignLabelToMenu();
  });

  $('.skiptocontent').on('focus', function() {
    $(this).addClass('skipToContent-visible');
  });
  $('.skiptocontent').on('focusout', function() {
    $(this).removeClass('skipToContent-visible');
  });
  let accountList = $('#accountLinkIds').val();
  if (accountList !== undefined) {
    accountList = accountList.split(',');
    let myAccountDynamicValues = $('.accNavComponent__child-wrap:first').find(
      'div'
    );

    for (let i = 0; i < accountList.length; i++) {
      myAccountDynamicValues.each(function() {
        let divHtml = document.getElementById(accountList[i]);
        if ($(this).attr('id') == accountList[i]) {
          $('.accNavComponent__child-wrap')
            .find('#' + accountList[i])
            .remove();
          $('.accNavComponent__child-wrap').append(divHtml);
        }
      });
    }
  }
  copyrightText = copyrightText.replace('year', new Date().getFullYear());
  $('.footer')
    .find('.copyRightTextYear')
    .html(copyrightText);
});
